import { Col, Typography } from "antd";

import CustomRow from "../../shared/costum-row/costum-row";

import { BREAKPOINTS } from "../../constants/styles";
import { HEADLINE_ORIENTATION } from "../../constants/props";

import useBreakpoints from "../../hooks/use-breakpoints";

import "./styles.scss";

const { Title } = Typography;

type HeadlineType = {
  title: string;
  subtitle: string | React.ReactNode;
  orientation: HEADLINE_ORIENTATION;
};

const Headline = ({ title, subtitle, orientation }: HeadlineType) => {
  const currentBreakpoint = useBreakpoints();

  const isMobile = currentBreakpoint === BREAKPOINTS.MOBILE.type;

  return (
    <CustomRow
      className={`Headline ${
        orientation === HEADLINE_ORIENTATION.TOP || isMobile
          ? "pt-2xl"
          : "pb-xl"
      } Headline-${orientation}`}
      align={orientation === HEADLINE_ORIENTATION.TOP ? "top" : "bottom"}
      justify={isMobile ? "center" : "space-between"}
      gutter={[0, 20]}
    >
      <Col xxl={12} xl={12} lg={16} md={16} sm={24} xs={24}>
        <Title className={`mb-3xs Headline-title`}>{title}</Title>
      </Col>
      <Col xxl={6} xl={6} lg={8} md={8} sm={24} xs={24}>
        <Title className={`Headline-subtitle`}>{subtitle}</Title>
      </Col>
    </CustomRow>
  );
};

export default Headline;
